import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import IP_URL from "../connect";
import LayersIcon from "@mui/icons-material/Layers";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../Redux/currentUserSlice";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Main = styled.div`
  background-color: #f4f8fb;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
  padding: 1rem;
  flex-wrap: wrap;
  gap: 1rem;

   @media(max-width: 600px){
  padding: 8px;
  gap:8px;
  }
`;

const Container = styled.div`
  flex: 1;
  min-width: 320px;
  margin-bottom: 50px;
  overflow-x: auto;
  background: white;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);

  @media(max-width: 600px){
  padding: 12px;
  }
`;

const Title = styled.h3`
  text-align: center;
  color: #0283e5;
  margin-bottom: 1rem;
  font-weight: 600;
`;

const Table = styled.table`
  border-collapse: collapse;
  background-color: #fdfdfd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: 100%;

  th, td {
    padding: 12px 15px;
    border: 1px solid #e0e0e0;
    text-align: center;
    white-space: nowrap;
  }

  th {
    background-color: #1976d2;
    color: white;
    font-weight: bold;
  }

  tbody tr {
    transition: background 0.2s ease;
  }

  tbody tr:nth-child(odd) {
    background-color: #cce5f8ff;
  }

  tbody tr:hover {
    background-color: #e3f2fd;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    th, td {
      padding: 6px 8px;
    }
  }
`;

const SearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  gap: 0.5rem;
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 150px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 14px;
  transition: 0.2s ease;

  &:focus {
    border-color: #0283e5;
    outline: none;
  }
`;

const DeleteBtn = styled.button`
  background: #e74c3c;
  border: none;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.3s;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #c0392b;
  }
`;

const AddBtn = styled.button`
  background: #00b894;
  border: none;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: 0.3s;

  &:hover {
    background: #009874;
  }
`;

const OrgList = styled.div`
  flex: 0.4;
  min-width: 250px;
  background: white;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  max-height: 75vh;
  overflow-y: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

const OrgCard = styled.div`
  background: #e3f2fd;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  transition: 0.2s ease;
  cursor: pointer;

  &:hover {
    background: #0283e5;
    color: white;
  }

  svg {
    margin-right: 8px;
    color: #0283e5;
  }

  &:hover svg {
    color: white;
  }
`;

const ConfirmModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ show }) => (show ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 2000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  text-align: center;
  width: 90%;
  max-width: 350px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);

  p {
    margin-bottom: 1rem;
    color: #333;
  }

  button {
    margin: 0 8px;
    padding: 6px 14px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
  }

  .cancel {
    background: #95a5a6;
    color: white;
  }

  .confirm {
    background: #e74c3c;
    color: white;
  }
`;

const Organization = () => {
  const [organizations, setOrganizations] = useState([]);
  const [searchOrganization, setSearchOrganization] = useState("");
  const [searchPhoneNumber, setSearchPhoneNumber] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const { token } = useSelector(selectUser);
  const navigate = useNavigate();

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  useEffect(() => {
    fetchOrganizations();
  }, []);

  const fetchOrganizations = async () => {
    try {
      const res = await fetch(`${IP_URL}/organization/all-orgs`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data) setOrganizations(data);
    } catch (error) {
      toast.error("Failed to load organizations");
    }
  };

  const handleDelete = async () => {
    if (!deleteId) return;
    try {
      const res = await fetch(`${IP_URL}/organization/${deleteId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data.success) {
        toast.success("Organization deleted successfully");
        fetchOrganizations();
      } else {
        toast.error(data.message || "Error deleting organization");
      }
    } catch (error) {
      toast.error("Server or network error");
    } finally {
      setDeleteId(null);
    }

    fetchOrganizations()
  };

  const filteredData = organizations.filter((org) => {
    return (
      (!searchOrganization ||
        org.userName?.toLowerCase().includes(searchOrganization.toLowerCase())) &&
      (!searchPhoneNumber || org.phoneNumber?.includes(searchPhoneNumber))
    );
  });

  return (
    <Main>
      <Navbar showMenuButton={true} toggleSidebar={toggleSidebar} />
      <Content>
        <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

        {/* Sidebar Org List */}
        <OrgList>
          <Title>Organizations</Title>
          {organizations.map((org, i) => (
            <OrgCard
              key={i}
              onClick={() => navigate(`/org-details/${org.uniqueKey}`)}
            >
              <LayersIcon />
              {org.userName}
            </OrgCard>
          ))}
        </OrgList>

        {/* Table Section */}
        <Container>
          <SearchContainer>
            <SearchInput
              placeholder="Search Organization"
              value={searchOrganization}
              onChange={(e) => setSearchOrganization(e.target.value)}
            />
            <SearchInput
              placeholder="Search Phone"
              value={searchPhoneNumber}
              onChange={(e) => setSearchPhoneNumber(e.target.value)}
            />
            <AddBtn onClick={() => navigate("/add-organization")}>
              <AddIcon /> Add Organization
            </AddBtn>
          </SearchContainer>

          <Table>
            <thead>
              <tr>
                <th>Organization</th>
                <th>Phone Number</th>
                <th>Meters</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((org, i) => (
                <tr
                  key={i}
                  onClick={() => navigate(`/org-details/${org.uniqueKey}`)}
                >
                  <td>{org.userName}</td>
                  <td>{org.phoneNumber}</td>
                  <td>{org.meters?.length || 0}</td>
                  <td>
                    <DeleteBtn
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteId(org._id);
                      }}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </DeleteBtn>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Container>
      </Content>

      <Footer />

      {/* Delete Confirmation Modal */}
      <ConfirmModal show={!!deleteId}>
        <ModalContent>
          <p>Are you sure you want to delete this organization?</p>
          <button className="cancel" onClick={() => setDeleteId(null)}>
            Cancel
          </button>
          <button className="confirm" onClick={handleDelete}>
            Delete
          </button>
        </ModalContent>
      </ConfirmModal>
    </Main>
  );
};

export default Organization;
